const baseurl = "https://api.lhrc.com.cn";
const baseimgurl = "https://img.lhrc.com.cn/";
const mapak = "Up7gmLUjWYQ2R4HQeOYmWQeaQlMOlzT5";
export default {
    baseurl,
    baseimgurl,
    mapak
}